import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const rootStyle = css`
  font-weight: 700;
  text-align: center;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 24px;
    padding-block: 106px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-block: 96px;
  }
`;
